import React, { memo } from 'react';

export type LaneShapeProps = {
	vbWidth: number;
	vbHeight: number;
	topWidthPct: number; // clamped externally if needed
	bottomWidthPct: number; // clamped externally if needed
};

/**
 * LaneShape
 *
 * Generates and renders the lane body path based on viewBox size and
 * top/bottom width percentages.
 */
export const LaneShape = memo(function LaneShape({
	vbWidth,
	vbHeight,
	topWidthPct,
	bottomWidthPct,
}: LaneShapeProps) {
	const topY = 0;
	const bottomY = vbHeight;
	const bottomWidthPx = (vbWidth * bottomWidthPct) / 100;
	const topWidthPx = (vbWidth * topWidthPct) / 100;
	const halfBottom = bottomWidthPx / 2;
	const halfTop = topWidthPx / 2;
	const centerX = vbWidth / 2;

	const leftTopX = centerX - halfTop;
	const leftBottomX = centerX - halfBottom;
	const rightTopX = centerX + halfTop;

	// Gentle outward bow using quadratic curves, matching previous logic
	const curveY = vbHeight * 0.1;
	const rightCtrlX = centerX + (halfTop + halfBottom) / 2 + Math.max(2, vbWidth * 0.02);
	const leftCtrlX = centerX - (halfTop + halfBottom) / 2 - Math.max(2, vbWidth * 0.02);

	const d = [
		`M ${leftTopX},${topY}`,
		`L ${rightTopX},${topY}`,
		`Q ${rightCtrlX},${curveY} ${centerX + halfBottom},${bottomY}`,
		`L ${leftBottomX},${bottomY}`,
		`Q ${leftCtrlX},${curveY} ${leftTopX},${topY}`,
		'Z',
	].join(' ');

	return <path d={d} className="lane-chooser__lane-shape" />;
});

export default LaneShape;
